module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"link":"友情链接","contact":"联系我们"},"ru":{"link":"Связь дружбы","contact":"Свяжись с нами."}}')
  delete Component.options._Ctor
}
